"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _lodash = require("lodash");

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var extractPropsFromMedia = function extractPropsFromMedia(element) {
  return {
    currentTime: element.currentTime * 1000,
    duration: element.duration * 1000,
    paused: element.paused,
    readyState: element.readyState,
    volume: element.volume,
    playbackRate: element.playbackRate
  };
};

var observePropsOnEvents = function observePropsOnEvents(element) {
  var slowEvents$ = (0, _rxjs.merge)((0, _rxjs.fromEvent)(element, "abort"), (0, _rxjs.fromEvent)(element, "canplay"), (0, _rxjs.fromEvent)(element, "canplaythrough"), (0, _rxjs.fromEvent)(element, "durationchange"), (0, _rxjs.fromEvent)(element, "emptied"), (0, _rxjs.fromEvent)(element, "ended"), (0, _rxjs.fromEvent)(element, "error"), (0, _rxjs.fromEvent)(element, "loadeddata"), (0, _rxjs.fromEvent)(element, "loadedmetadata"), (0, _rxjs.fromEvent)(element, "loadstart"), (0, _rxjs.fromEvent)(element, "playing"), (0, _rxjs.fromEvent)(element, "progress"), (0, _rxjs.fromEvent)(element, "ratechange"), (0, _rxjs.fromEvent)(element, "seeking"), (0, _rxjs.fromEvent)(element, "stalled"), (0, _rxjs.fromEvent)(element, "suspend"), (0, _rxjs.fromEvent)(element, "timeupdate"), (0, _rxjs.fromEvent)(element, "volumechange"), (0, _rxjs.fromEvent)(element, "waiting"), (0, _rxjs.fromEvent)(element, "speedchange")).pipe((0, _operators.auditTime)(50, _rxjs.animationFrameScheduler));
  var fastEvents$ = (0, _rxjs.merge)((0, _rxjs.fromEvent)(element, "seeked"), (0, _rxjs.fromEvent)(element, "pause"), (0, _rxjs.fromEvent)(element, "play"), (0, _rxjs.fromEvent)(element, "playbackRate")).pipe((0, _operators.auditTime)(0, _rxjs.animationFrameScheduler));
  return (0, _rxjs.merge)(slowEvents$, fastEvents$).pipe((0, _operators.map)(function (event) {
    return extractPropsFromMedia(event.target);
  }), (0, _operators.startWith)(extractPropsFromMedia(element)));
};

var MediaStore = function MediaStore(mediaNode$) {
  var mediaUserEvents$ = new _rxjs.BehaviorSubject();
  var nodeEvents$ = mediaNode$.pipe((0, _operators.switchMap)(function (elem) {
    return observePropsOnEvents(elem);
  }), (0, _operators.map)(function (props) {
    return {
      __id: "RECEIVE_EVENT_MEDIA",
      props: props
    };
  }));
  var $ = (0, _rxjs.merge)(mediaUserEvents$, nodeEvents$).pipe((0, _operators.withLatestFrom)(mediaNode$), (0, _operators.scan)(function (state, _ref) {
    var _ref$ = _ref[0],
        action = _ref$ === void 0 ? {} : _ref$,
        domNode = _ref[1];

    switch (action.__id) {
      case "PLAY_MEDIA":
        domNode.play();
        return state;

      case "PAUSE_MEDIA":
        domNode.pause();
        return state;

      case "SKIP_PREV_NEXT_HIT":
        state.skipPrevNextHit = action.status;
        return _extends({}, state);

      case "SEEK_MEDIA":
        var _action$time = action.time,
            _action$time$s = _action$time.s,
            s = _action$time$s === void 0 ? null : _action$time$s,
            _action$time$p = _action$time.p,
            p = _action$time$p === void 0 ? null : _action$time$p;

        if ((0, _lodash.isNumber)(s)) {
          state.currentTime = s;
          domNode.currentTime = s / 1000;
        } // if (isNumber(p)) {


        state.currentPosition = p; // }

        return _extends({}, state);

      case "SET_VOLUME_MEDIA":
        domNode.volume = action.volume;
        return state;

      case "RECEIVE_EVENT_MEDIA":
        return _extends({}, state, action.props);

      case "SET_SENTIMENT_ANALYZER":
        return _extends({}, state, {
          isSentimentAnalyzerOn: action.isSentimentAnalyzerOn
        });

      case "SET_KEYWORD_ANALYZER":
        return _extends({}, state, {
          isKeywordAnalyzerOn: action.isKeywordAnalyzerOn
        });

      case "SET_PHRASE_SPORTING_ANALYZER":
        return _extends({}, state, {
          isPhraseSupportingAnalyzerOn: action.isPhraseSupportingAnalyzerOn
        });

      case "SET_VERB_NOUN_ANALYZER":
        return _extends({}, state, {
          isVerbNounAnalyzerOn: action.isVerbNounAnalyzerOn
        });

      case "SET_ENTITIES_ANALYZER":
        return _extends({}, state, {
          isEntitiesAnalyzerOn: action.isEntitiesAnalyzerOn
        });

      case "SET_PLAYBACK_SPEED":
        domNode.playbackRate = action.playbackRate;
        return _extends({}, state, {
          playbackRate: action.playbackRate
        });

      case "SET_INTERACTION_TYPE":
        return _extends({}, state, {
          interactionType: action.type
        });

      default:
        return state;
    }
  }, {}), (0, _operators.distinctUntilChanged)(), (0, _operators.shareReplay)(1));
  return {
    $: $,
    destroy: function destroy() {
      [mediaUserEvents$, nodeEvents$, $].forEach(function (store) {
        if ((0, _lodash.isFunction)((0, _lodash.get)(store, "complete"))) store.complete();
      });
    },
    actions: {
      playMedia: function playMedia() {
        return mediaUserEvents$.next({
          __id: "PLAY_MEDIA"
        });
      },
      pauseMedia: function pauseMedia() {
        return mediaUserEvents$.next({
          __id: "PAUSE_MEDIA"
        });
      },
      seekMedia: function seekMedia(time) {
        return mediaUserEvents$.next({
          __id: "SEEK_MEDIA",
          time: time
        });
      },
      skipPrevNextHit: function skipPrevNextHit(status) {
        return mediaUserEvents$.next({
          __id: "SKIP_PREV_NEXT_HIT",
          status: status
        });
      },
      setVolumeMedia: function setVolumeMedia(volume) {
        return mediaUserEvents$.next({
          __id: "SET_VOLUME_MEDIA",
          volume: volume
        });
      },
      setSentimentAnalyzer: function setSentimentAnalyzer(isSentimentAnalyzerOn) {
        return mediaUserEvents$.next({
          __id: "SET_SENTIMENT_ANALYZER",
          isSentimentAnalyzerOn: isSentimentAnalyzerOn
        });
      },
      setKeywordAnalyzer: function setKeywordAnalyzer(isKeywordAnalyzerOn) {
        return mediaUserEvents$.next({
          __id: "SET_KEYWORD_ANALYZER",
          isKeywordAnalyzerOn: isKeywordAnalyzerOn
        });
      },
      setPhraseSupportingAnalyzer: function setPhraseSupportingAnalyzer(isPhraseSupportingAnalyzerOn) {
        return mediaUserEvents$.next({
          __id: "SET_PHRASE_SPORTING_ANALYZER",
          isPhraseSupportingAnalyzerOn: isPhraseSupportingAnalyzerOn
        });
      },
      setVerbNounAnalyzer: function setVerbNounAnalyzer(isVerbNounAnalyzerOn) {
        return mediaUserEvents$.next({
          __id: "SET_VERB_NOUN_ANALYZER",
          isVerbNounAnalyzerOn: isVerbNounAnalyzerOn
        });
      },
      setEntitiesAnalyzer: function setEntitiesAnalyzer(isEntitiesAnalyzerOn) {
        return mediaUserEvents$.next({
          __id: "SET_ENTITIES_ANALYZER",
          isEntitiesAnalyzerOn: isEntitiesAnalyzerOn
        });
      },
      setPlaybackSpeed: function setPlaybackSpeed(playbackRate) {
        return mediaUserEvents$.next({
          __id: "SET_PLAYBACK_SPEED",
          playbackRate: playbackRate
        });
      },
      setInteractionType: function setInteractionType(type) {
        return mediaUserEvents$.next({
          __id: "SET_INTERACTION_TYPE",
          type: type
        });
      }
    }
  };
};

var _default = MediaStore;
exports["default"] = _default;